

import { defineComponent } from 'vue';
import { ConfirmModalOptions } from '~/models/modals/confirm-modal-options.model';

import ModalBase from './modal-base';

export default defineComponent({

    extends: ModalBase,

    data() {
        return {
            title: '',
            question: '',
            ok: this.$t('global.ok'),
            cancel: this.$t('global.cancel'),
        };
    },

    mounted(): void {
        this.$eventBus.on('confirm.open', (parameters: { title: string, question: string, options: ConfirmModalOptions}) => {
            this.title = parameters.title;
            this.options = parameters.options ? parameters.options: {};

            this.question = parameters.question;
           
            if(this.options.okLabel) {
                this.ok = this.options.okLabel;
            }

            if(this.options.cancelLabel) {
                this.cancel = this.options.cancelLabel;
            }

            this.open();
        })
    },

    unmounted(): void {
        this.$eventBus.off('confirm.open')
    },


    methods: {
        confirm(): void {
            this.$eventBus.emit('confirm.submit', true);
            this.close();
        },

        onClose(): void {
            this.$eventBus.emit('confirm.submit', false);
        }
    }
});
